import React from 'react';
import { FILTER_OPTIONS } from '../../constants';

const selectClass = "w-full sm:w-auto min-w-0 px-3 py-2 border border-stone-200 rounded-lg bg-stone-50 text-stone-900 text-sm focus:ring-2 focus:ring-amber-500 focus:border-amber-500 transition-colors";

const FilterControls = ({ filterCategory, filterType, onCategoryChange, onTypeChange }) => {
  return (
    <div className="mb-4 flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-4 min-w-0">
      <div className="w-full sm:w-auto min-w-0">
        <label className="block text-xs sm:text-sm font-medium text-stone-700 mb-1 sm:mb-0 sm:inline sm:mr-2">Filter by Category:</label>
        <select
          value={filterCategory}
          onChange={(e) => onCategoryChange(e.target.value)}
          className={`${selectClass} mt-1 sm:mt-0`}
        >
          <option value={FILTER_OPTIONS.CATEGORY.ALL}>All</option>
          <option value={FILTER_OPTIONS.CATEGORY.STARTERS}>Starters</option>
          <option value={FILTER_OPTIONS.CATEGORY.SOUPS}>Soups</option>
          <option value={FILTER_OPTIONS.CATEGORY.BREADS}>Breads</option>
          <option value={FILTER_OPTIONS.CATEGORY.RICE}>Rice</option>
          <option value={FILTER_OPTIONS.CATEGORY.BIRYANI}>Biryani</option>
          <option value={FILTER_OPTIONS.CATEGORY.MAIN_COURSE}>Main Course</option>
          <option value={FILTER_OPTIONS.CATEGORY.CURRIES}>Curries</option>
          <option value={FILTER_OPTIONS.CATEGORY.TANDOOR}>Tandoor</option>
          <option value={FILTER_OPTIONS.CATEGORY.CHINESE}>Chinese</option>
          <option value={FILTER_OPTIONS.CATEGORY.BEVERAGES}>Beverages</option>
          <option value={FILTER_OPTIONS.CATEGORY.DESSERT}>Dessert</option>
          <option value={FILTER_OPTIONS.CATEGORY.TODAYS_SPECIAL}>Today's Special</option>
          <option value={FILTER_OPTIONS.CATEGORY.BREAKFAST}>Breakfast</option>
          <option value={FILTER_OPTIONS.CATEGORY.LUNCH}>Lunch</option>
          <option value={FILTER_OPTIONS.CATEGORY.MEAL}>Meal</option>
        </select>
      </div>
      <div className="w-full sm:w-auto min-w-0">
        <label className="block text-xs sm:text-sm font-medium text-stone-700 mb-1 sm:mb-0 sm:inline sm:mr-2">Filter by Type:</label>
        <select
          value={filterType}
          onChange={(e) => onTypeChange(e.target.value)}
          className={`${selectClass} mt-1 sm:mt-0`}
        >
          <option value={FILTER_OPTIONS.TYPE.ALL}>All</option>
          <option value={FILTER_OPTIONS.TYPE.VEG}>Veg</option>
          <option value={FILTER_OPTIONS.TYPE.NON_VEG}>Non-Veg</option>
        </select>
      </div>
    </div>
  );
};

export default FilterControls;
